/**
 * Vehicle Start Measurement Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.vehicleStartMeasurementFormatter = function(value, row) {
    let html = '';
    if (parseInt(row.can_start, 10) === 1) {
        html += '<button class="button-vehicle-start-measurement btn btn-sm btn-outline-success me-3" data-id="'+row.vehicle_id+'" data-name="'+row.name+'">';
        html += __('Start measurement');
        html += '</button>';
    } else {
        html += '<button class="btn btn-sm btn-outline-secondary disabled me-3">';
        html += __('Start measurement');
        html += '</button>';
    }
    return html;
};
